import {getCustomerById} from "../../pages/Customers/functions";

export const getCustomerAddressesById = async (id) => {
    const customer = await getCustomerById(id);
    return customer.person.addresses;
}
export const getCustomerAddressesObjectById = async (id) => {
    const addresses = await getCustomerAddressesById(id);
    const customerAddressesObject = addresses.map((address ) => {
        return {
            id : address.id,
            value : address.id,
            label : `${address.town.name} - ${address.address}`
        };
    });
    return customerAddressesObject;
}